import { AfterViewInit, Directive, Inject, Input } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';

import { CommonWindow } from '@core/domain/models/common-window.model';

@Directive({
    selector: '[cmsAkamaiDynamicPosterVideo]',
})
export class CmsAkamaiDynamicPosterVideoDirective implements AfterViewInit {
    @Input() public cmsIdElement: string;

    @Input() public cmsAkamaiDynamicPosterVideo: Array<{ width: number; src: string }>;

    constructor(
        @Inject(WINDOW) private readonly window: CommonWindow,
    ) {}

    public ngAfterViewInit() {
        if (this.cmsAkamaiDynamicPosterVideo?.length > 0) {
            const cssRules = [];
            this.cmsAkamaiDynamicPosterVideo.forEach((breakpoint, index) => {
                const prevWidth = index === 0 ? 0 : this.cmsAkamaiDynamicPosterVideo[index - 1].width;
                const mediaQuery = `(min-width: ${prevWidth}px) and (max-width: ${breakpoint.width}px)`;
                const cssRule = `@media screen and ${mediaQuery} {
                        #${this.cmsIdElement} {
                            background-image: url('${breakpoint.src}');
                        }
                    }`;
                cssRules.push(cssRule);
            });
            const style = this.window.document.createElement('style');
            style.innerHTML = cssRules.join('');
            this.window.document.head.appendChild(style);
        }
    }
}
